import React, { useState } from 'react' 
import styled from 'styled-components'
import './styles.scss'
import classNames from 'classnames'

const Nav = (props) => {
    const [active, setActive] = useState(false)

    return (
        <MainNav className="navbar is-fixed-top" role="navigation">
            <div className="navbar-brand">
                <a className="navbar-item" href="/">
                    <img src="/logo.svg" alt="Logo" width="60" />
                </a>
                <div className={classNames("navbar-burger burger", active && 'is-active')} data-target="nav" onClick={e => setActive(!active)}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <div id="nav" className={classNames("navbar-menu", active && 'is-active')}>
                    <div className="navbar-start">
                        <div className="navbar-item">
                            <a href="#about" className="link">
                                <span className="item">
                                    1. 
                                </span>
                                <span>About Me</span>
                            </a>
                        </div>
                        <div className="navbar-item">
                            <a href="#technologies" className="link">
                                <span className="item">
                                    2. 
                                </span>
                                <span>Technologies</span>
                            </a>
                        </div>
                        <div className="navbar-item">
                            <a href="#experiences" className="link">
                                <span className="item">
                                    3. 
                                </span>
                                <span>Experiences</span>
                            </a>
                        </div>
                        <div className="navbar-item">
                            <a href="#contact" className="link">
                                <span className="item">
                                    4. 
                                </span>
                                <span>Contact</span>
                            </a>
                        </div>
                    </div>
                   
                </div>
            </div>
        </MainNav>
    )
}

const MainNav = styled.nav `
    background: #070f1f;
    padding: 1rem;
    box-shadow: 0px 15px 32px -3px rgba(7,15,31,0.75);
    -webkit-box-shadow: 0px 15px 32px -3px rgba(7,15,31,0.75);
    -moz-box-shadow: 0px 15px 32px -3px rgba(7,15,31,0.75);
`

export default Nav;